import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'AppYcang',
    component: () => import('../views/AppYcang.vue'),
  },
  {
    path: '/AppYcang',
    name: 'AppYcang',
    component: () => import('../views/AppYcang.vue'),
  },
]


const router = new VueRouter({
  // mode: 'history',
  routes
})
// 全局处理路由错误
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      throw err
    }
  })
}

export default router
